import axios from 'axios';

import {
  publicAxiosHeader,
  axiosHeader,
  getV1RootUrl
} from 'common/helpers/apiHelper';

export const getCustomer = () =>
  axios.get(`${getV1RootUrl()}/customer/self`, axiosHeader());

export const loginCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/login`,
    loginObject,
    publicAxiosHeader()
  );

export const logoutCustomer = () =>
  axios.post(`${getV1RootUrl()}/customer/logout`, {}, axiosHeader());

export const unsubscribeCustomer = (customerId, payload) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/unsubscribe`,
    payload,
    publicAxiosHeader()
  );

export const fbLoginOrCreateCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/facebook-login-or-create`,
    loginObject,
    publicAxiosHeader()
  );

export const googleLoginOrCreateCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/google-login-or-create`,
    loginObject,
    publicAxiosHeader()
  );

export const validateMagicLinkId = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/magic-link-login`,
    loginObject,
    publicAxiosHeader()
  );

export const validateResetPasswordId = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/reset-password-login`,
    loginObject,
    publicAxiosHeader()
  );

export const addCustomer = (customer) =>
  axios.post(`${getV1RootUrl()}/customer`, customer, publicAxiosHeader());

export const addCustomerWithAddress = (customer) =>
  axios.post(
    `${getV1RootUrl()}/customer-address`,
    customer,
    publicAxiosHeader()
  );

export const editCustomer = (customerId, customer) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}`,
    customer,
    axiosHeader()
  );

export const editCustomerPassword = (customerId, customer) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/password`,
    customer,
    axiosHeader()
  );

export const forgotPassword = (emailObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/generate-reset-password-link`,
    emailObject,
    publicAxiosHeader()
  );

export const magicLink = (data) =>
  axios.post(
    `${getV1RootUrl()}/customer/generate-magic-link`,
    data,
    publicAxiosHeader()
  );

export const resetPassword = (resetObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/reset-password`,
    resetObject,
    publicAxiosHeader()
  );
